import {
  Box,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import ModalHeader from "./ModalHeader";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DataFilter from "../View/Biggbarains/Common/DataFilter";

let refreshFilter;

const FilterModal = ({
  handleRefresh,
  setQuery,
  query,
  queryParam,
  ifStatusFilter,
  ifProjectNameFilter,
  ifPriorityFilter,
  ifCategoryFilter,
  ifAssignedToFilter,
  ifCreatedByFilter,
   ifemployeeFilter,
  unassigned,
  clearHookCb,
  refresh,
}) => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (clearHookCb) clearHookCb(refreshFilter);

  useEffect(() => {
    if (handleRefresh) {
      handleClose();
    }
  }, [handleRefresh]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : "55%", // Responsive width

    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    fontFamily: "Poppins",
    p: isMobile ? 2 : 4, // Smaller padding for mobile
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: isMobile ? 0.5 : 1,
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500, color: "#333" }}>
          Apply Filters
        </Typography>
        <Tooltip title="Open Filters">
          <IconButton
            onClick={handleOpen}
            sx={{
              bgcolor: "#1976d2",
              color: "#fff",
              "&:hover": { bgcolor: "#125aa0" },
              borderRadius: "8px",
              p: isMobile ? 1 : 1.5,
            }}
          >
            <FilterAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <ModalHeader title="Filter Options" handleClose={handleClose} />
          <Box sx={{gap:2}}>
            <DataFilter
              ifStatusFilter={ifStatusFilter}
              ifProjectNameFilter={ifProjectNameFilter}
              ifPriorityFilter={ifPriorityFilter}
              ifCategoryFilter={ifCategoryFilter}
              ifAssignedToFilter={ifAssignedToFilter}
              ifCreatedByFilter={ifCreatedByFilter}
               ifemployeeFilter={ifemployeeFilter}
              unassigned={unassigned}
              setQuary={setQuery}
              query={queryParam}
              clearHookCb={(cb) => {
                refreshFilter = cb;
              }}
              refresh={refresh}
              handleClose={handleClose}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default FilterModal;
